import React from 'react';
import {
    Collapse,
    NavItem,
    NavLink as BSNavLink,
  } from 'reactstrap';

import {
    MdKeyboardArrowDown,
  } from 'react-icons/md';

import { NavLink } from 'react-router-dom';
import bn from 'utils/bemnames';

const bem = bn.create('sidebar');

class ItemColMenu extends React.Component {

    render(){
      let {titulo, nombre, modulo, isOpen, handleClick, Icon, classIcon} = this.props; 
        return (
            <div className="menu-modulo">
              <NavItem
                className={bem.e('nav-item')}
                onClick={handleClick(nombre)}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex">
                    <Icon className={bem.e('nav-item-icon') + ' icono-'+classIcon} />
                    <span className="nombre-modulo">{titulo}</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      padding: 0,
                      transform: isOpen
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transitionDuration: '0.3s',
                      transitionProperty: 'transform',
                    }}
                  />
                </BSNavLink>
              </NavItem>

              <Collapse isOpen={isOpen}>
                {modulo.map(({ to, name, exact, Icon, subMenu, subMenuName, isOpenSub}, index) => {
                  return to!=='' ?
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      className="submenu"
                      tag={NavLink}
                      to={to}
                      activeClassName="active"
                      exact={exact}
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span className="nombre-seccion"> {name}</span>
                    </BSNavLink>
                  </NavItem>
                  : 
                  <div key={index}>
                    <NavItem
                      className={bem.e('nav-item')}
                      onClick={handleClick(subMenuName)}
                    >
                      <BSNavLink className={bem.e('nav-item-collapse submenu')}>
                        <div className="d-flex">
                          <Icon className={bem.e('nav-item-icon')} />
                          {name}
                        </div>
                        <MdKeyboardArrowDown
                          className={bem.e('nav-item-icon')}
                          style={{
                            padding: 0,
                            transform: isOpenSub
                              ? 'rotate(0deg)'
                              : 'rotate(-90deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                          }}
                        />
                      </BSNavLink>
                    </NavItem>

                    <Collapse isOpen={isOpenSub}>
                      {subMenu.map(({ to, name, exact, Icon }, index) => (
                        <NavItem key={index} className={bem.e('nav-item')}>
                          <BSNavLink
                            id={`navItem-${name}-${index}`}
                            className="submenu-item"
                            tag={NavLink}
                            to={to}
                            activeClassName="active"
                            exact={exact}
                          >
                            <Icon className={bem.e('nav-item-icon')} />
                            <span className="nombre-seccion">{name}</span>
                          </BSNavLink>
                        </NavItem>
                      ))}
                    </Collapse>

                  </div>

                })}
              </Collapse>
            </div>
            
        )
    }


}

export default ItemColMenu; 